import { useEffect } from 'react'
import { isEmpty } from 'lodash-es'

import { useSiteQuery } from '../../../global/blocs/useSite'

interface WindowTitleComponentProps {
  title: string
}

const WindowTitleComponent = ({ title }: WindowTitleComponentProps) => {
  const { data: siteData } = useSiteQuery()

  useEffect(() => {
    document.title = !isEmpty(title)
      ? title
      : (siteData?.site_name ?? 'Webinar Room')
  }, [title, siteData])

  return null
}

export default WindowTitleComponent
